export enum ShipmentMethodEnum {

    RETAILSTORE = 'RETAIL STORE',
    ESTOREONLINECATALOGUE= 'E STORE / ONLINE / CATALOGUE',
    DISCOUNTSTORE ='DISCOUNT STORE',
    MARKETINGFASHIONSHOW= 'MARKETING/ FASHION SHOW',
    RAWMATERIALSALETOSHAHISSUPPLIER = `RAW MATERIAL SALE TO SHAHI'S SUPPLIER`,
    RAWMATERIALSALETOBUYERSSUPPLIER = `RAW MATERIAL SALE TO BUYER'S SUPPLIER`
 }
 